import React, { ReactElement } from 'react';
import TableRow from '../../../../../components/table-row/table-row.component';
import VisibleCell from '../../../../../components/visible-cell/visible-cell.component';
import SettingsPortfolioRowForm from '../settings-portfolio-row-form/settings-portfolio-row-form.component';

const SettingsPortfolioRow: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isActive,
    isSaving,
    isSaveDisabled,
    isInlineSaving,
    isEditMode,
    portfolioItem,
    portfolioGroupList,
    portfolioMarkerColorList,
    portfolioIndex,
    tablePortfolioListFields,
    inputRefs,
    onRowClick,
    onInlineSave,
    onInlineCancel,
  } = props;

  return (
    isEditMode && isActive ? (
      <SettingsPortfolioRowForm
        isActive={isActive}
        isSaving={isSaving}
        isSaveDisabled={isSaveDisabled}
        isInlineSaving={isInlineSaving}
        portfolioMarkerColorList={portfolioMarkerColorList}
        portfolioGroupList={portfolioGroupList}
        portfolioData={portfolioItem}
        portfolioIndex={portfolioIndex}
        inputRefs={inputRefs}
        onInlineSave={onInlineSave}
        onInlineCancel={onInlineCancel}
      />
    ) : (
      <TableRow
        isButton={!isEditMode}
        onClick={(event: React.MouseEvent<Element, MouseEvent>): void => {
          onRowClick(event, portfolioItem);
        }}
      >
        {
          tablePortfolioListFields.map((tableField: TableField): ReactElement | boolean => (
            <VisibleCell isEditMode={isEditMode} key={tableField.id} tableField={tableField}>
              {!!tableField.component && tableField.component(portfolioItem)}
            </VisibleCell>
          ))
        }
      </TableRow>
    )
  );
});

export default SettingsPortfolioRow;
